import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LoginCrud } from '../utilities/LoginCrud';
import { useUser } from '../Contexts/AuthenticatedUserContext';
import { Userx } from '../DTO/Userx';
import { API_BASE_URL } from '../config/config';
import { Layout } from '../Layout';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError]       = useState('');

    const navigate        = useNavigate();
    const { setCurrentUser } = useUser();

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const response = await LoginCrud.tryUserLogin({ username, password });
            if (response.status === 200) {
                const { data } = await axios.get(`${API_BASE_URL}/api/users/me`);
                const user = new Userx(data);
                setCurrentUser(user);
                localStorage.setItem('isAuthenticated', 'true');
                navigate('/');
            } else {
                setError('Login failed. Please try again.');
            }
        } catch (err) {
            console.error('Login failed:', err);
            setError('Login failed. Please try again.');
        }
    };

    return (
        <Layout>
            <div className="page-container pt-14 md:pt-20 pb-24">
                <form onSubmit={handleLogin} className="max-w-sm">
                    <h1 className="text-[clamp(2.25rem,5vw,3rem)] leading-[1.05] mb-3">Sign in</h1>
                    <p className="text-muted mb-8">Admin access for managing projects, posts and users.</p>

                    <div className="flex flex-col gap-5">
                        <div>
                            <label htmlFor="username" className="label block mb-1.5">Username</label>
                            <input
                                id="username"
                                type="text"
                                autoComplete="username"
                                required
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                className="input"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="label block mb-1.5">Password</label>
                            <input
                                id="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                className="input"
                            />
                        </div>

                        {error && (
                            <p role="alert" className="m-0 text-error font-label text-base">{error}</p>
                        )}

                        <button type="submit" className="btn-primary self-start mt-1">
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </Layout>
    );
};

export default Login;
